export default {
  C: "C",
  CSharp: "C♯",
  D: "D",
  DFlat: "D♭",
  DSharp: "D♯",
  E: "E",
  EFlat: "E♭",
  F: "F",
  FSharp: "F♯",
  G: "G",
  GFlat: "G♭",
  GSharp: "G♯",
  A: "A",
  AFlat: "A♭",
  ASharp: "A♯",
  B: "B",
  BFlat: "B♭",

  correctExcl: "Правильно!",
  wrongExcl: "Хибно!",

  ABORT: "СКАСУВАТИ",

  lastRound: "Останій раунд",
  score: "Рахунок",
  accuracy: "Точність",
  correct: "Правильних",
  wrong: "Хибних",

  START: "СТАРТ",
  settings: "Налаштування",
  ROUND_LENGTH: "ДОВЖИНА РАУНДА",
  NOTE_INPUT: "ВВІД НОТ",
  CLEF: "КЛЮЧ",
  DIFFICULTY: "СКЛАДНІСТЬ",
  ACCIDENTALS: "АЛЬТЕРАЦІЯ",
  LANGUAGE: "МОВА",
  twentySeconds: "20 с",
  oneMinute: "1 хв",
  fiveMinutes: "5 хв",
  infinite: "Нескінченно",
  buttons: "Кнопки",
  piano: "Піаніно",
  trebleClef: "Скрипічний",
  bassClef: "Басовий",
  altoClef: "Альто",
  tenorClef: "Тенор",
  pianoClef: "Піаніно",
  easy: "Простий",
  normal: "Нормальний",
  hard: "Важкий",
  none: "Нічого",
  sharp: "♯",
  flat: "♭",
  sharpAndFlat: "♯ та ♭",
  SOUND: "ЗВУК",
  VIBRATION: "ВІБРАЦІЯ",
  DISPLAYCORRECTNOTE: "ПОКАЗУВАТИ ПРАВИЛЬНУ НОТУ",
  on: "Вкл",
  off: "Викл",

  TIME: "ЧАС",
  CORRECT: "ПРАВИЛЬНО",
  ACCURACY: "ТОЧНІСТЬ",
  SCORE: "РАХУНОК",

  record: "Таблиця результатів",
  history: "Історія",

  noMidiSupport: "Вибачте, схоже, що ваш пристрій не підтримує MIDI.",
  noDeviceFound: "Пристрій не знайдено. Підключіть пристрій MIDI знову.",
  playTheNote: "Зіграйте ноту на MIDI-клавіатурі.",
  lastNotePlayed: "Зіграно останню ноту",
};



// WEBPACK FOOTER //
// ./src/resources/ua.js